<template>
  <div>
    <TopHead
      :top-type="'black'"
      :title="spver === 1 ? '' : '播单'"
    />
    <div class="bd-top">
      <figure class="bd-info-box">
        <figcaption>{{ playListData.title }}</figcaption>
        <p class="bd-info-tag">
          <template v-for="(v, index) in tags">
            <span :key="index">{{ v }}</span>
            <em
              v-if="index !== tags.length - 1 && tags.length > 1"
              :key="index"
            >/</em>
          </template>
        </p>
        <p
          v-if="playListData.quantity && playListData.quantity > 0"
          class="bd-info-num"
        >
          共 {{ playListData.quantity }} 部作品
        </p>
      </figure>
      <div
        v-if="playListData.introduction"
        class="bd-info-text"
      >
        <div :class="['bd-info-detail', { clip: fold }, { fix: fix }]">
          <p class="fake-content">
            {{ playListData.introduction }}
          </p>
          <p class="bd-info-detail-intro">
            {{ playListData.introduction }}
          </p>
          <div
            v-if="clip"
            class="bd-info-detail-more"
            @click="unfoldIntro"
          >
            <span>展开</span>
            <i />
          </div>
        </div>
      </div>
    </div>
    <Info :bodan-list="playListData.bodan_list || []" />
    <RelatedPlayList :initial-data="playListData.relatedInfo" />
    <Gotop />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Gotop from '../common/components/Gotop.vue';
import RelatedPlayList from '../common/components/RelatedPlayList.vue';
import TopHead from '../common/components/TopHead.vue';
import pageExpose from '../common/mixins/pageExpose';
import Info from './components/Info.vue';

export default {
  components: {
    TopHead,
    Info,
    RelatedPlayList,
    Gotop,
  },
  mixins: [pageExpose],
  data() {
    return {
      showLoading: false,
      fold: true,
      clip: false,
      fix: false,
    };
  },
  computed: {
    ...mapState('playlist', ['playListData']),
    spver() {
      return +this.$route.query.spver === 1 ? 1 : 0;
    },
    tags() {
      const { playListData } = this;
      const tags = (playListData.tag || '').split(';');
      if (tags && tags.length >= 3) {
        tags.splice(3);
      }
      return tags;
    },
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('playlist/prefetchData', { context, route })
      .catch(err => console.log('[PREFETCH_PLAY_LIST_ERROR]', err));
  },
  mounted() {
    const self = this;
    const fakeDom = document.querySelector('.fake-content');
    if (fakeDom !== null) {
      const f = fakeDom.offsetHeight;
      if (f > 75) {
        self.fix = true;
        self.clip = true;
      }
    }
  },
  methods: {
    unfoldIntro() {
      this.fold = false;
    },
  },
};
</script>

<style lang="scss">
@import '../../asset/css/abstracts/mixin.scss';
@import '../../asset/css/abstracts/function_sprite_playlist.scss';

.bd-info-box {
  overflow: hidden;
  figcaption {
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: normal;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: block;
    display: -webkit-box;
    font-size: 25px;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    line-height: 37px;
    margin-bottom: 12px;
  }
}

.bd-info-tag {
  white-space: nowrap;
  float: left;
  font-size: 13px;
  font-weight: 400;
  line-height: 13px;
  color: rgba(153, 153, 153, 1);
  //margin-bottom:20px;
  span {
    margin: 0 5px;
  }
  span:first-of-type {
    margin-left: 0;
  }
}

.bd-info-num {
  position: relative;
  float: right;
  vertical-align: middle;
  font-size: 13px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 13px;
}
.bd-info-text {
  background: rgba(247, 247, 247, 1);
  border-radius: 5px;
}
.fake-content {
  padding-right: 14px;
  position: absolute;
  z-index: -1; /* 隐藏 */
  opacity: 0; /* 透明 */
  pointer-events: none; /*元素不可交互/点击*/
}
.bd-info-detail {
  margin-top: 20px;
  padding: 12px 14px;
  position: relative;

  .bd-info-detail-more {
    display: none;
  }

  > p {
    font-size: 15px;
    font-weight: 400;
    color: rgba(85, 85, 85, 1);
    line-height: 25px;
    //position:relative;
  }

  &.clip {
    .bd-info-detail-intro {
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .bd-info-detail-more {
      display: block;
      position: absolute;
      right: 0;
      bottom: 12px;
      background-color: #f7f7f7;
      line-height: 25px;

      &:before {
        content: '';
        display: block;

        position: absolute;
        top: 0;
        left: -50px;
        width: 50px;
        height: 25px;
        background: -webkit-gradient(
          linear,
          right top,
          left top,
          from(rgba(247, 247, 247, 1)),
          to(rgba(255, 255, 255, 0))
        );
        background: -webkit-linear-gradient(right, rgba(247, 247, 247, 1), rgba(255, 255, 255, 0));
        background: -moz-linear-gradient(right, rgba(247, 247, 247, 1), rgba(255, 255, 255, 0));
        background: linear-gradient(to left, rgba(247, 247, 247, 1), rgba(255, 255, 255, 0));
      }

      span {
        margin-right: 28px;
        font-size: 15px;
        font-weight: 400;
        color: rgba(85, 85, 85, 1);
      }
      i {
        @include arr(4px, 135deg, rgba(0, 0, 0, 0.7));
        @extend %-vertical-center;
        right: 19px;
      }
    }
    &.fix {
      height: 75px;
    }
  }
}
.bd-top {
  padding: 0 15px 24px;
  position: relative;
}
</style>
